'use strict';
let debounce = require('lodash/debounce');
let addToWishlist = require('../product/base').addToWishlist;

let isLoading = false;
let hasMoreProducts = true;
let nextUrl = '';
let scrollTimeout;

/**
 * Funzione principale per caricare i prodotti (usata dallo scroll)
 */
function loadMoreProducts() {
  if (!hasMoreProducts || isLoading) return;
  
  isLoading = true;
  window.$.spinner().start();
  
  $.ajax({
    url: nextUrl,
    data: { selectedUrl: nextUrl },
    method: 'GET',
    success: function (response) {
      let $response = $(response);

      let $currentFooter = $('.grid-footer');
      if ($currentFooter.length) {
        $currentFooter.remove();
      }

      let $newProducts = $response.filter('.product, .product-tile-container');
      if ($newProducts.length === 0) {
        $newProducts = $response.find('.product, .product-tile-container, [data-pid]');
      }
  
      let $container = $('.product-grid, .grid, .search-results, .product-tiles');
      if ($newProducts.length) {
        if ($container.length) {
          $container.append($newProducts);
        } else {
          $('main, .container').append($newProducts);
        }
        $(document).trigger('content:updated', [$newProducts]);
      }

      let $newFooter = $response.filter('.grid-footer').add($response.find('.grid-footer'));
      let $nextLink = $response.filter('.show-more .btn-primary, .show-more a, .load-more')
                                .add($response.find('.show-more .btn-primary, .show-more a, .load-more'));

      if ($newFooter.length) {
        $container.append($newFooter);
      }

      if ($nextLink.length) {
        nextUrl = $nextLink.attr('href');
        attachScrollListener();
      } else {
        let dataNextUrl = $response.filter('[data-next-url]').attr('data-next-url') ||
                          $response.find('[data-next-url]').attr('data-next-url');
        
        if (dataNextUrl) {
          nextUrl = dataNextUrl;
        } else {
          hasMoreProducts = false;
          $(window).off('scroll.infiniteScroll');
        }
      }

      if (typeof updateSortOptions === 'function') {
        updateSortOptions(response);
      } else {
        let $tempDom = $('<div>').append($(response));
        let sortOptions = $tempDom.find('.grid-footer').data('sort-options');
        if(sortOptions && sortOptions.options) {
             sortOptions.options.forEach(function (option) {
                $('option.' + option.id).val(option.url);
             });
        }
      }
      
      if (typeof updateUrlParams === 'function') {
        updateUrlParams(nextUrl);
      }
      
      isLoading = false;
      window.$.spinner().stop();

      setTimeout(function() {
        $(window).trigger('scroll');
      }, 100);
    },
    error: function (xhr, status, error) {
      console.error("AJAX error:", status, error);
      isLoading = false;
      window.$.spinner().stop();
    }
  });
}

/**
 * Gestisce l'evento scroll
 */
function handleScroll() {
  if (!hasMoreProducts) return;
  
  let scrollTop = $(window).scrollTop();
  let windowHeight = $(window).height();
  let documentHeight = $(document).height();
  let threshold = Math.min(1800, documentHeight * 0.4);
  
  if (scrollTop + windowHeight >= documentHeight - threshold) {
    loadMoreProducts();
  }
}

/**
 * Attacca il listener allo scroll (con debounce)
 */
function attachScrollListener() {
  $(window).off('scroll.infiniteScroll').on('scroll.infiniteScroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(handleScroll, 150);
  });
}

/**
 * Ricalcola lo stato (chiamata dopo init e dopo applyFilter)
 */
function resetInfiniteScrollState() {
  isLoading = false;
  hasMoreProducts = true;
  nextUrl = '';

  let $initialLink = $('.show-more .btn-primary, .show-more a, .load-more, .js-show-more');
  
  if ($initialLink.length) {
    nextUrl = $initialLink.attr('href');
  } else {
    let hiddenNextUrl = $('.grid-footer').data('next-url') || 
                        $('body').data('next-page-url') ||
                        $('.pagination').find('a[rel="next"]').attr('href');
    
    if (hiddenNextUrl) {
      nextUrl = hiddenNextUrl;
    } else {
      hasMoreProducts = false;
    }
  }

  if (hasMoreProducts) {
    attachScrollListener();
    setTimeout(handleScroll, 500);
  } else {
    $(window).off('scroll.infiniteScroll');
  }
  
  console.log("Scroll Reset. HasMore:", hasMoreProducts, "NextUrl:", nextUrl);
}

function updateUrlParams(url, redirect, reset) {
  let baseUrl = window.location.href;
  if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
  if (baseUrl.indexOf('?') !== -1) baseUrl = baseUrl.split('?')[0];
  history.replaceState(undefined, '', baseUrl);

  let lastSegment = baseUrl.endsWith('/') ? baseUrl.slice(0, -1).split('/').pop() : baseUrl.split('/').pop();
  if (lastSegment.indexOf('?') !== -1) lastSegment = lastSegment.split('?')[0];

  const newUrl = new URL(url, baseUrl);
  let params = new URLSearchParams(newUrl.search);
  let searchParams = new URLSearchParams(params);

  if (searchParams.has('sz') && searchParams.has('start')) {
    searchParams.set('sz', parseInt(searchParams.get('start'), 10) + parseInt(searchParams.get('sz'), 10));
    searchParams.set('start', 0);
  }

  const categoryParam = searchParams.has('cgid') ? searchParams.get('cgid') : null;
  if (categoryParam) {
    if (categoryParam !== lastSegment && redirect) {
      if (redirect.endsWith('/')) redirect = redirect.slice(0, -1);
      history.replaceState(undefined, '', redirect);
      baseUrl = window.location.href;
    }
    if (reset) {
      if (reset.endsWith('/')) reset = reset.slice(0, -1);
      history.replaceState(undefined, '', reset);
      baseUrl = window.location.href;
    }
  }

  let pageUrl = searchParams.values().next().value !== undefined ? '?' + searchParams : '';
  history.pushState(undefined, '', pageUrl);
}

function init(scrollPos, category) {
  let currentUrl = window.location.href;
  const activecategory = $('.product-grid').attr('categoryid');
  if (category && category.match(/\s+/g)) {
    category = category.replace(/\s+/g, '+');
  }
  
  if ((currentUrl.indexOf(category) !== -1 || category === activecategory) && scrollPos > 0) {
    $(window).scrollTop(scrollPos);
  }
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
  let $updates = $results.find(selector);
  if ($updates.length > 0) {
    $(selector).empty().html($updates.html());
  }
}

function updateCategories(cat) {
  if ($(`[data-refinement-value="${cat.id}"]`).length > 0) {
    $(`[data-refinement-value="${cat.id}"]`).removeClass('disabled');
    $(`[data-refinement-value="${cat.id}"]`).closest('li').removeClass('disabled');
    $(`[data-refinement-value="${cat.id}"]`).data('href', cat.url);
    if (cat.selected) {
      $(`[data-refinement-value="${cat.id}"]`).addClass('selected');
    }
  }

  if (!cat.subCategories.length === 0) {
    return;
  }

  cat.subCategories.forEach(function (subCat) {
    if ($(`[data-refinement-value="${subCat.id}"]`).length > 0) {
      $(`[data-refinement-value="${subCat.id}"]`).removeClass('disabled');
      $(`[data-refinement-value="${subCat.id}"]`).closest('li').removeClass('disabled');
      $(`[data-refinement-value="${subCat.id}"]`).data('href', subCat.url);
      if (subCat.selected) {
        $(`[data-refinement-value="${subCat.id}"]`).addClass('selected');
      }
    }
    updateCategories(subCat);
  });
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
  let $results = $(response);
  // Update DOM elements that do not require special handling
  ['.plp-top-container', '.grid-header', '.product-grid', '.show-more', '.filters-bar'].forEach(function (selector) {
    updateDom($results, selector);
  });
}

function updateFilters(url) {
  let filtersUrl = $('.js-filters-panel').data('filtersEndpoint');
  if (url.indexOf('?') !== -1) {
    filtersUrl = filtersUrl + '?' + url.split('?')[1];
  }

  $.ajax({
    url: filtersUrl,
    method: 'GET',
    success: function (response) {
      if (response.refinements.length > 0) {
        // Update each filter count
        response.refinements.forEach(function (refinement) {
          if ($(`.refinement-${refinement.id}`).length > 0) {
            let refName = $(`.refinement-${refinement.id}`).find('.refinement-name');
            if (!refName.length > 0) return;
            if (refName && refinement.selectedFiltersCount > 0) {
              let span = `${refinement.displayName} <span class="selected-filters" aria-hidden="true"><span class="sr-only">${refinement.selectedFiltersCount}</span></span>`;
              refName[0].innerHTML = span;
            } else {
              refName[0].innerHTML = refinement.displayName;
            }
          }
        });

        //Update filters url, enable/disable filters
        const allValues = response.refinements
          .map(function ({ values }) {
            return values;
          })
          .flat();
        const allFilters = document.querySelectorAll('[data-refinement-value]');
        [...allFilters].forEach(function (filter) {
          $(filter).removeClass('selected');
          $(filter).addClass('disabled');
          $(filter).closest('li').addClass('disabled');
        });

        allValues.forEach(function (value) {
          if (value.type === 'category') {
            updateCategories(value);
          } else {
            if ($(`[data-refinement-value="${value.value}"]`).length > 0) {
              if (value.selectable || value.type === 'price') {
                $(`[data-refinement-value="${value.value}"]`).removeClass('disabled');
                $(`[data-refinement-value="${value.value}"]`).closest('li').removeClass('disabled');
              }
              $(`[data-refinement-value="${value.value}"]`).data('href', value.url);
              $(`[data-refinement-value="${value.value}"]`).find('.hitCount').html('');
              if (value.hitCount > 0) {
                $(`[data-refinement-value="${value.value}"]`).find('.hitCount').html(value.hitCount);
              }
              if (value.selected) {
                $(`[data-refinement-value="${value.value}"]`).addClass('selected');
                $(`[data-refinement-value="${value.value}"]`).attr('data-href', value.url);
                $(`[data-refinement-value="${value.value}"]`).attr('data-refinement', value.refinementsUrl);
              }
            }
          }
        });

        let filtersApplied = response.refinements.find(function (ref) {
          return ref.selectedFiltersCount > 0;
        });

        $('.js-reset-filter').addClass('d-none');
        if (filtersApplied) {
          $('.js-reset-filter').removeClass('d-none');
        }
      }

      // Update sorting options
      if (response.sortingOptions && response.sortingOptions.options.length > 0) {
        response.sortingOptions.options.forEach(function (option) {
          if ($(`#${option.id}`).length > 0) {
            $(`#${option.id}`).val(option.url);
            $(`#${option.id}`).attr('checked', false);
            if (response.sortingOptions.ruleId === option.id) $(`#${option.id}`).attr('checked', 'checked');
          }
        });
      }
    },
    error: function () {},
  });
}

// function replaceEl(response) {
//   let $results = $(response);
//   ['.grid-header-subcategories .selected', '.product-grid'].forEach(function (selector) {
//     let $updates = $results.find(selector);
//     if ($updates.length > 0) {
//       $(selector).empty().replaceWith($updates);
//     }
//   });
// }

function enableCta() {
  $('.js-show-result').removeClass('disabled').prop('disabled', false);
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
  let showMoreUrl = $element.data('url');
  window.$.spinner().start();
  $.ajax({
    url: showMoreUrl,
    method: 'GET',
    success: function (response) {
      $target.append(response);
      window.$.spinner().stop();
    },
    error: function () {
      window.$.spinner().stop();
    },
  });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
  let $tempDom = $('<div>').append($(response));
  let sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
  sortOptions.forEach(function (option) {
    $('option.' + option.id).val(option.url);
  });
}

function setCurrentSrule() {
  if ($('#refinement-sort input[name=sort-order]:checked').length) {
    let selectedSortRule = $('#refinement-sort input[name=sort-order]:checked')[0].dataset.label;
    $('.js-srule-label').empty().html(selectedSortRule);
  }
}

function saveScrollPos() {
  sessionStorage.scrollPos = window.pageYOffset;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const cgid = urlParams.get('cgid') || $('.product-grid').attr('categoryid') || '';
  const q = urlParams.get('q');
  sessionStorage.category = cgid || q;
}

module.exports = {

  initBrandCategoryFilter: () => {
    if(document.querySelector('.filter-dropdown[data-name="categoryCode"] ul') && document.querySelector('#list-button-copied-in-plp ul')){
      let elToCopyGroup = document.querySelector('.filter-dropdown[data-name="categoryCode"] ul').innerHTML;
      let elToPast = document.querySelector('#list-button-copied-in-plp ul');
      if(document.querySelectorAll('.filter-dropdown[data-name="categoryCode"] ul li').length>1){ 
        // Add listing top filter only if > 1
        elToPast.innerHTML = elToCopyGroup;
        elToPast.style.display="block";
      } else {
        elToPast.style.display="none";
      }
      
    }
    
    document.addEventListener('click',function(e){
      let target = e.target;
      while (target && target.parentNode !== document) {
        if (!target) { return; }
        if ( target.matches('button.refinement') ){
            const refer = target.getAttribute('data-refinement-value');
            const items = document.querySelectorAll('div[data-name="categoryCode"] .refinement');
            for (let i=0; i< items.length; i++){
              if(items[i].hasAttribute('data-refinement-value') && items[i].getAttribute('data-refinement-value')===refer){
                items[i].click();
              }
            }
        }
        target = target.parentNode;
      }
    },true);
  },

  filter: function () {
    // Display refinements bar when Menu icon clicked
    $('.grid-header').on('click', 'button.filter-results', function () {
      $('.refinement-bar, .modal-background').show();
      $('.refinement-bar').siblings().attr('aria-hidden', true);
      $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
      $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
      $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
      $('.refinement-bar .close').focus();
    });
  },

  closeRefinements: function () {
    // Refinements close button
    $('.grid-header').on('click', '.refinement-bar button.close, .modal-background', function () {
      $('.refinement-bar, .modal-background').hide();
      $('.refinement-bar').siblings().attr('aria-hidden', false);
      $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
      $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
      $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
      $('.btn.filter-results').focus();
    });
  },

  resize: function () {
    // // Close refinement bar and hide modal background if user resizes browser
    // $(window).resize(function () {
    //   $('.refinement-bar, .modal-background').hide();
    //   $('.refinement-bar').siblings().attr('aria-hidden', false);
    //   $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
    //   $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
    //   $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
    // });
  },

  sort: function () {
    setCurrentSrule();
    // Handle sort order menu selection
    $('.js-filters-panel').on('change', '[name=sort-order]', function (e) {
      e.preventDefault();
      setCurrentSrule();
      window.$.spinner().start();
      let url = this.value;
      updateFilters(url);
      $(this).trigger('search:sort', this.value);
      $.ajax({
        url: url,
        data: { selectedUrl: this.value },
        method: 'GET',
        success: function (response) {
          let $grid = $('.product-grid');
          $grid.empty().html(response);
          enableCta();
          updateUrlParams(url);
          window.$.spinner().stop();
        },
        error: function () {
          window.$.spinner().stop();
        },
      });
    });
  },

  showMore: function () {
    resetInfiniteScrollState();
  },

  applyFilter: function () {
    $('.js-filters-panel').on('click', '.refinement, .js-reset-filter, .refinement-reset', function (e) {
      e.preventDefault();
      e.stopPropagation();

      window.$.spinner().start();
      $(this).trigger('search:filter', e);
      let url = $(this).data('href');
      
      if(typeof updateFilters === 'function') updateFilters(url);

      let _this = $(this);
      $.ajax({
        url: url,
        data: {
          page: $('.grid-footer').data('page-number'),
          selectedUrl: url,
        },
        method: 'GET',
        success: function (response) {
          if(typeof parseResults === 'function') parseResults(response);
          
          if (response.error) {
            window.location.href = response.redirectUrl;
          } else {
            let reset = _this.data('reset');
            updateUrlParams(url, reset);
          }

          resetInfiniteScrollState();

          window.$.spinner().stop();
        },
        error: function () {
          window.$.spinner().stop();
        },
      });
    });
  },

  closeFilterPanel: function () {
    $('.js-filters-panel').on('click', '.js-show-result', function (e) {
      e.preventDefault();
      window.EventBus.emit(window.CUSTOM_MESSAGES.MODAL_EVENTS.CLOSE, { id: 'filters-modal' });
    });
  },

  showContentTab: function () {
    $('.container').on('click', '.content-search', function () {
      if ($('#content-search-results').html() === '') {
        getContent($(this), $('#content-search-results'));
      }
    });

    $('.container').on('click', '.show-more-content button', function () {
      getContent($(this), $('#content-search-results'));
      $('.show-more-content').remove();
    });
  },

  addToWishlist: addToWishlist,

  scroll: function () {
    window.addEventListener('scroll', debounce(saveScrollPos, 100));
    window.onload = init(sessionStorage.scrollPos, sessionStorage.category);
  },

  refinementCategories: function() {
    $('div#refinement-category .content button[data-name]').each((index, button) => {
        if($(`div#refinement-categoriesRefinement .values button[data-refinement-value="${$(button).data('name')}"]`).length) {
            $(`div#refinement-categoriesRefinement .values button[data-refinement-value="${$(button).data('name')}"]`).addClass('show-filter')
        }
    })
  }

};
